import { normalizePath } from "../../lib/pages";
import { industryForPath } from "../../lib/marketing-projects";
import { DocsPage } from "./docs";
import {
  HomePage,
  ProductPage,
  UseCasesPage,
  PricingPage,
  ChangelogPage,
  PrivacyPage,
  SupportPage,
  NotFoundPage,
} from "./pages";
import { Layout } from "./ui";
import { TermsPage } from "./terms";
import { ImpressumPage } from "./impressum";
import {
  AgentSetupPage,
  BlogArticle,
  BlogPage,
  ChatGPTMarketingPage,
  CommunityPage,
  ConnectionsPage,
} from "./destination-pages";
export function MarketingApp({ path }: { path: string }) {
  const route = normalizePath(path);
  const industry = industryForPath(route);
  const page =
    route === "/connect/chatgpt" ? (
      <ChatGPTMarketingPage />
    ) : route === "/connect/claude" ? (
      <AgentSetupPage claude />
    ) : route === "/connect/agent" ? (
      <AgentSetupPage />
    ) : route === "/community" ? (
      <CommunityPage />
    ) : route === "/blog" ? (
      <BlogPage />
    ) : route === "/blog/shared-design-canvas" ? (
      <BlogArticle slug="shared-design-canvas" />
    ) : route === "/blog/bring-your-agent" ? (
      <BlogArticle slug="bring-your-agent" />
    ) : route === "/" ? (
      <HomePage />
    ) : route === "/product" ? (
      <ProductPage />
    ) : route === "/use-cases" || industry ? (
      <UseCasesPage industrySlug={industry?.slug} />
    ) : route === "/integrations" ? (
      <ConnectionsPage />
    ) : route === "/pricing" ? (
      <PricingPage />
    ) : ["/docs", "/docs/workspace", "/docs/mcp", "/docs/api"].includes(
        route,
      ) ? (
      <DocsPage path={route} />
    ) : route === "/changelog" ? (
      <ChangelogPage />
    ) : route === "/terms" ? (
      <TermsPage />
    ) : route === "/impressum" ? (
      <ImpressumPage />
    ) : route === "/support" || route === "/contact" ? (
      <SupportPage />
    ) : route === "/privacy" ? (
      <PrivacyPage />
    ) : (
      <NotFoundPage />
    );
  return <Layout path={route}>{page}</Layout>;
}
